import { Tooltip as ReactTooltip } from "react-tooltip";
import "./Tooltip.css";

/**
 * The house tooltip.
 *
 * `id` is all most callers need. Anything else (`className`, `delayShow`, `delayHide`,
 * `offset`, …) passes straight through to react-tooltip, so a caller can widen it or tune its
 * timing without a second tooltip implementation growing beside this one.
 */
const Tooltip = ({ id, className = "", ...rest }) => {
  return (
    <ReactTooltip
      id={id}
      border="1px solid rgba(202, 212, 231, 0.50)"
      background="white"
      className={`tooltip ${className}`.trim()}
      render={({ content }) => (
        <span dangerouslySetInnerHTML={{ __html: content?.replace("<br />","")}} />
      )}
      noArrow
      style={{
        borderRadius: "12px",
        background: "#FFF",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.03)",
        padding: "12px 16px",
        color: "var(--dark-blue)",
        fontFamily: '"Noto Sans"',
        fontSize: "12px",
        lineHeight: "16px",
        zIndex: 9999,
      }}
      {...rest}
    />
  );
};

export default Tooltip;
